import React from 'react';
import { motion } from 'framer-motion';
import { Map, Flame, Utensils, ArrowRight } from 'lucide-react';
interface Step {
  num: string;
  icon: React.ReactNode;
  title: string;
  text: string;
}
const steps: Step[] = [{
  num: '01',
  icon: <Map className="w-6 h-6" strokeWidth={1.75} data-id="element-203" />,
  title: 'Descarga el Mapa',
  text: 'Descarga el Mapa del Método Fuego Cero para planificar tu próxima visita al súper.'
}, {
  num: '02',
  icon: <Flame className="w-6 h-6" strokeWidth={1.75} data-id="element-204" />,
  title: 'Aplica el Reset 72h',
  text: 'Aplica el Protocolo Reset 72 horas para apagar la inflamación y sentir el cambio rápido.'
}, {
  num: '03',
  icon: <Utensils className="w-6 h-6" strokeWidth={1.75} data-id="element-205" />,
  title: 'Cocina en 15 min',
  text: 'Sigue las recetas de 15 minutos y nota cómo tu ropa empieza a quedarte holgada de nuevo.'
}];
export function HowItWorks() {
  return <section className="py-14 md:py-16 bg-brand-navy text-white relative overflow-hidden" data-id="element-206">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-207" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl relative z-10" data-id="element-208">
        {/* Heading */}
        <div className="text-center mb-14" data-id="element-209">
          <p className="text-brand-gold text-xs sm:text-sm font-bold uppercase tracking-[0.2em] mb-3" data-id="element-210">
            Tres pasos
          </p>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-cream leading-tight" data-id="element-211">
            ¿Cómo funciona?
          </h2>
          <p className="text-brand-cream/70 mt-4 text-base sm:text-lg" data-id="element-212">
            Simple, rápido y diseñado para tu realidad chilena.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 relative" data-id="element-213">
          {/* Connecting dotted line for desktop */}
          <div className="hidden md:block absolute top-12 left-[18%] right-[18%] h-px border-t-2 border-dashed border-brand-gold/30 z-0" data-id="element-214" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-215">
              {/* Number circle with icon overlay */}
              <div className="relative mb-6" data-id="element-216">
                <div className="w-24 h-24 rounded-full bg-brand-navy border-4 border-brand-gold flex items-center justify-center shadow-[0_0_30px_rgba(212,164,55,0.25)]" data-id="element-217">
                  <span className="font-serif font-bold text-3xl text-brand-gold" data-id="element-218">
                    {step.num}
                  </span>
                </div>
                {/* Icon badge */}
                <div className="absolute -bottom-2 -right-2 w-11 h-11 rounded-full bg-brand-gold text-brand-navy flex items-center justify-center shadow-lg ring-4 ring-brand-navy" data-id="element-219">
                  {step.icon}
                </div>
              </div>

              {/* Title */}
              <h3 className="font-serif font-bold text-xl text-brand-cream mb-3" data-id="element-220">
                {step.title}
              </h3>

              {/* Description */}
              <p className="text-base text-brand-cream/80 leading-relaxed max-w-xs" data-id="element-221">
                {step.text}
              </p>

              {/* Mobile arrow between steps */}
              {index < steps.length - 1 && <div className="md:hidden flex justify-center mt-8 mb-2" data-id="element-222">
                  <ArrowRight className="w-5 h-5 text-brand-gold/50 rotate-90" data-id="element-223" />
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}